/* eslint-disable react-hooks/exhaustive-deps */
/* https://stackoverflow.com/questions/42267189/how-to-get-value-translatex-by-javascript */
import { Icon } from "@blueprintjs/core"
import { CSSProperties, DragEvent, MouseEvent, useEffect, useRef } from "react"
import { ID } from "src/libs/interfaces/layouts"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { HISTORY_TYPE, IHistoryStep, ILanding, IScreenPosition, LANDING_EDIT_MODE, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent" 
import doShoWPanelData from "../../UIX/utils/doShowPanelData"
import { editMeat } from "./content-edit/editMeat"
import RotateHandler from "./RotateHandler"
import WidthHandler from "./WidthHandler"
import HeightHandler from "./HeightHandler"
import { SelectMenu } from "./SelectMenu"
import createMeat from "./utils/createMeat" 
import updateSelectedPosition from "./utils/updateSelectedPosition"
import updateHistory from "./utils/updateHistory"
import { __ } from "src/libs/utilities"
import resetPosition from "./utils/resetPosition"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import Transformer from "./transformer/Transformer"
import { getLandingContainer } from "../../utils/getLandingContainer"
import { useLandingScroll } from "src/modules/pe-landing-module/hooks/useLandingScroll"

/* Protopia Ecosystem component */
export interface IContentClickFormProps {
   
}
const ContentClickForm = (props: IContentClickFormProps): JSX.Element => {
    const ref = useRef(null)
    const sizes                     = useLandingStore((state: ILandingStore) => state.landingRect)
    const doubleClickType           = useLandingStore((state: ILandingStore) => state.doubleClickType)
    const zoom: number              = useLandingStore((state: ILandingStore) => state.zoom)
    const editMode                  = useLandingConsoleStore((state:ILandingConsoleStore) => state.editMode)
    const select                    = useSyncState<any>(null) 
    const selectContent             = useSyncState<any>(null) 
    const id                        = useSyncState<ID>("")
    const sectionId                 = useSyncState<ID>("")
    const type                      = useSyncState<string>("")
    const startDragPos              = useSyncState<DOMRect>({} as DOMRect)
    const isStartDrag               = useSyncState<boolean>(false)
    const selectType                = useSyncState<SELECT_TYPE>(SELECT_TYPE.NONE)
    const selectedData              = useSelectedContent()
    const lScroll = useLandingScroll()

    const deselect = () => {
        select.set(null)
        selectContent.set(null) 
        useLandingStore.setState({ selectedFloat: "", selectedMeat: "" })
        useLandingConsoleStore.setState({editMode: LANDING_EDIT_MODE.EDIT}) 
    }
    const onClick = ( evt: any ) => {
        const selection = window.getSelection()
        if ((selection?.direction || "none")  !== "none") {
            return null
        }
        if( doubleClickType !== SELECT_TYPE.NONE ) {
            return null
        }
        const clickType     = evt.target.closest("[data-select-type]") 
        if(clickType?.getAttribute("data-select-type") === "ignore") {
            return null
        }
        const meat          = evt.target.closest(".landing-section-container > .landing-data-components-container > .landing-section-data-animation > .landing-section-data-position > .landing-content-container") 
        const float         = evt.target.closest(".is-edit .landing-float-container [data-content-id][data-is-canvas='false']")
        const title         = evt.target.closest(".landing-section-container > .landing-section-title-container > .title-animation-container") 
        const delimiter     = evt.target.closest(".landing-section-container > .landing-delimiter") 
        const background    = evt.target.closest(".landing-section-bg-color, .landing-section-bg-image") 
        const menus         = evt.target.closest(".landing-data-panel-btn")
         
        let section: any  
        if(!!float) {
            evt.stopPropagation()
            evt.preventDefault()
            select.set(float)
            selectType.set(SELECT_TYPE.FLOAT)
            selectContent.set( select.get().getBoundingClientRect() )
            section = select.get().closest(".landing-section-container.landing-gap[id]")
            sectionId.set(section?.getAttribute("id") || "" )
            const _id = select.get().getAttribute("data-content-id") || ""
            id.set(_id)
            Transformer.setSelected({
                id: _id,
                sectionId: sectionId.get(),
                type: "",
                selectedType: SELECT_TYPE.FLOAT,
                bound: selectContent.get(),
            })
        }  
        else if( !!meat ) {
            evt.stopPropagation()
            evt.preventDefault() 
            select.set(meat) 
            selectType.set(SELECT_TYPE.CONTENT)
            selectContent.set( select.get().closest(".landing-edit-cont").getBoundingClientRect() )
            section = select.get().closest(".landing-section-container.landing-gap[id]")
            sectionId.set(section?.getAttribute("id") || "") 
            const _id = select.get().getAttribute("data-content-id") || ""
            id.set(_id)
            type.set(select.get().getAttribute("data-type") || "")
            Transformer.setSelected({
                id: _id,
                sectionId: sectionId.get(),
                type: type.get(),
                selectedType: SELECT_TYPE.CONTENT,
                bound: selectContent.get(),
            })
        }
        else if(!!title) {
            evt.stopPropagation()
            evt.preventDefault()
            select.set(title)
            selectType.set(SELECT_TYPE.TITLE)
            selectContent.set( select.get().getBoundingClientRect() )
            section = select.get().closest(".landing-section-container.landing-gap[id]")
            sectionId.set(section?.getAttribute("id") || "" ) 
            id.set("-1") 
            // Transformer.setSelected({
            //     id: "-1",
            //     sectionId: sectionId.get(),
            //     type: "",
            //     selectedType: SELECT_TYPE.TITLE,
            //     bound: selectContent.get(),
            // })
        }
        else if(!!delimiter) {
            evt.stopPropagation()
            evt.preventDefault()
            select.set(delimiter)
            selectType.set(SELECT_TYPE.DELIMITER)
            selectContent.set( select.get().getBoundingClientRect() )
            section = select.get().closest(".landing-section-container.landing-gap[id]")
            sectionId.set(section?.getAttribute("id") || "" ) 
            id.set(-1) 
            // Transformer.setSelected({
            //     id: "-1",
            //     sectionId: sectionId.get(),
            //     type: "",
            //     selectedType: SELECT_TYPE.DELIMITER,
            //     bound: selectContent.get(),
            // }) 
        }
        else if(!!background) { 
            evt.stopPropagation()
            evt.preventDefault()
            // select.set(background)
            // setSelectContent( select.get().getBoundingClientRect() )
            selectType.set(SELECT_TYPE.BACKGROUND) 
            section = background.closest(".landing-section-container.landing-gap[id]")
            sectionId.set(section?.getAttribute("id") || "")
            id.set(-1)  

            // Transformer.setSelected({
            //     id: "-1",
            //     sectionId: sectionId.get(),
            //     type: "",
            //     selectedType: SELECT_TYPE.BACKGROUND,
            //     bound: selectContent.get(),
            // }) 
            deselect()
        }
        else if(!!menus) {
            
        }
        else {
            deselect()
        }
    }

    const onScroll = () => { 
        if(!!select.get()) {
            selectContent.set( select.get().closest(".landing-edit-cont").getBoundingClientRect() )
        }
    }
    useEffect(() => {
        const landing = getLandingContainer() 
        landing.addEventListener("scroll", onScroll)
        landing.addEventListener("click", onClick)
        const timeout = setTimeout(() => { landing.click() }, 2)
        
        return () => { 
            clearTimeout( timeout )
            landing.removeEventListener("scroll", onScroll)
            landing.removeEventListener("click", onClick)
        }
    }, []) 
    useEffect(() => { 
        select.set( null )
        selectContent.set( null )
    }, [ zoom ])
    
    if( doubleClickType !== SELECT_TYPE.NONE ) {
        return <></>
    }

    const onDragStart = (event:DragEvent) => {   
        event.dataTransfer.setDragImage(event.currentTarget, window.outerWidth, window.outerHeight)
        const rect = (ref.current! as Element).getBoundingClientRect() 
        const pos = {
            ...rect,
            top: event.clientY,
            left: event.clientX,
        }
        // console.log("START drag >> pos:", pos)
        isStartDrag.set( true ) 
        startDragPos.set( pos ) 
    }
    const onDrag = ( event: DragEvent ) => { 
        if( !!isStartDrag.get() ) {
            const top           = event.clientY  - startDragPos.get().top;
            const left          = event.clientX  - startDragPos.get().left;
            const position      = { ...selectedData.data?.position, top, left }
            // Transformer.setPosition( position )
            getTransformElement().style.transform = `rotate(${ position?.rotate || 0 }deg) translateX(${ left }px) translateY(${ top }px) scale(1)` 
            onScroll()
        } 
    }
    const  onDragEnd = ( event: DragEvent ) => { 
        const top           = event.clientY - startDragPos.get().top  - sizes.top;
        const left          = event.clientX - startDragPos.get().left - sizes.left;
        const position      = { ...selectedData.data?.position, top, left }
        getTransformElement().style.transform = `rotate(${ position.rotate || 0 }deg) translateX(${ position.left }px) translateY(${ position.top }px) scale(1)`;
        
        // console.log("END drag >> top:", top, "left:", left) 
        
        updateSelectedPosition(
            {
                id: id.get(),
                position : {
                    left,
                    top, 
                }
            },
            selectedData.type
        )
        isStartDrag.set( false )
        selectContent.set( select.get().getBoundingClientRect() )
        // selectContent.set(null)
        // onScroll() 
    }
    const onHeightDrag = (height: number) => {
        
    }
    const onHeightDragEnd = (height: number) => {
        const position      = selectedData.data?.position || {}
        updateSelectedPosition(
            {
                id: id.get(),
                position : {
                    ...position,
                    height
                }
            },
            selectedData.type
            
        )
        //onScroll() 
        selectContent.set(null)       
    }
    const onRotateStart = (evt: DragEvent) => {
        evt.dataTransfer.setDragImage((evt.target as any), window.outerWidth, window.outerHeight);
        (ref.current as any).style.transformOrigin = "center center"
        isStartDrag.set( false )
        evt.stopPropagation()
    }
    const onRotate = (evt: DragEvent) => {  
        const y = evt.clientY - selectContent.get().top  
        const rotate = Math.floor( Math.atan2( y , evt.clientX ) / Math.PI * 360 ) 
        //console.log( "ROTATE: ", rotate, selectedData );
        const pos = selectedData?.data?.position || {};
        (ref.current as any).style.transform = `translateX(${pos.left || 0}px) translateY(${pos.top || 0}px) rotate(${ rotate }deg)`
        isStartDrag.set( false )
        evt.stopPropagation() 
    }
    const onRotateEnd = (evt: DragEvent) => { 
        const y = evt.clientY - selectContent.get().top
        const rotate = Math.floor( Math.atan2( y , evt.clientX ) / Math.PI * 360 ) 
        console.log( "ROTATE END:", rotate, selectedData )
        const position = selectedData?.data?.position || {}
        updateSelectedPosition(
            {
                id: id.get(),
                position : {
                    ...position,
                    rotate 
                }
            },
            selectedData.type
        ) 
        isStartDrag.set( false )
        // selectContent.set(null)
        evt.stopPropagation() 
    }

    const getTransformElement = (): any => {
        switch (selectedData.type) {
            case SELECT_TYPE.FLOAT: 
                return select.get().closest(".landing-float-position-container")
            case SELECT_TYPE.CONTENT:
                return select.get().closest(".landing-section-data-position")
            case SELECT_TYPE.TITLE:
                return select.get().querySelector(".title-position-container")
            default:
                return ""
        }
    }
    const getTransformTargetStyle = ( ): CSSProperties => {
        const pos = selectedData?.data?.position || {}
        switch (selectedData.type) { 
            case SELECT_TYPE.NONE:
            case undefined:
                return {}
            case SELECT_TYPE.FLOAT: 
                return { 
                    top: selectContent.get().y + lScroll - sizes.top, 
                    left: selectContent.get().x - sizes.left, 
                    width: pos.width,
                    height: pos.height,
                    transform: `translateX(${ 0 }px) translateY(${ 0 }px) rotate(${ pos.rotate || 0 }deg)`
                }
            case SELECT_TYPE.TITLE: 
            case SELECT_TYPE.CONTENT:
            default: 
                return { 
                    top: selectContent.get().top + lScroll - sizes.top, 
                    left: selectContent.get().x - sizes.left, 
                    width: selectContent.get().width,
                    height: selectContent.get().height,
                    transform: `translateX(${pos.left || 0}px) translateY(${pos.top || 0}px) rotate(${pos.rotate || 0}deg)`
                }
        }
    }
    
    const position = selectedData?.data?.position || {}
    
    if( !!selectContent.get() ) {
        return <div 
            className='position-absolute landing-content-click-form z-index-80'
            style={getTransformTargetStyle()}
            draggable
            onDragStart={onDragStart}
            onDrag={onDrag}
            onDragEnd={onDragEnd}
            ref={ref}
        >
            <div 
                className="current-select" 
                style={{
                    width: getTransformTargetStyle().width,
                    height: getTransformTargetStyle().height
                }} 
            >
                <div className={`current-dimentions text-nowrap d-none`}>
                    <span className="mr-2 title text-nowrap">
                        { id ? `#${id.get()}` : `` }
                    </span>
                    <span className="text-nowrap">
                        { position.width } <Icon icon="small-cross" size={9} /> { position.height }
                    </span>
                    
                </div>
            </div>
            <RotateHandler 
                style={{ left:selectContent.get().width - 32 , top: -20 }} 
                onDragStart={onRotateStart}
                onDrag={onRotate}
                onDragEnd={onRotateEnd}
            />
            <div className={`d-flex position-absolute left m-0 w-100`} style={{top: selectContent.get().width > 60 ? 0 : -31 }}>  
                <SelectMenu 
                    selectType={ selectType.get() } 
                    type={ type.get() } 
                    value={ selectedData.data }
                />
            </div>
            <HeightHandler 
                style={{ left: selectContent.get().width / 2 - 24, top: selectContent.get().height - 23 }} 
                onDragStart={()=> {}}
                onDrag={onHeightDrag}
                onDragEnd={onHeightDragEnd}
            
            />
            {/* 
            <WidthHandler 
                style={{ left: selectContent.get().width - 24, top: selectContent.get().height / 2 - 24 }} 
            />  
            */}
            <div className="central-cross" style={{ left: selectContent.get().width / 2, top: selectContent.get().height / 2 }} />
        </div>
    }
        
    return <></>
}
export default ContentClickForm